import { useState } from "react";
import {
	getStorage,
	ref,
	uploadBytes,
	getDownloadURL,
	deleteObject,
} from "firebase/storage";

// Por defecto Storage sirve los archivos con `private, max-age=0`, así que el
// navegador vuelve a bajar cada imagen en cada visita. Con esto se cachean.
const UPLOAD_METADATA = { cacheControl: "public, max-age=604800" };

export default function useFirebase() {
	const [loading, setLoading] = useState<boolean>(false);

	// Función para cargar un archivo a Cloud Storage de Firebase
	const uploadFileToStorage = (file: File, path: string): Promise<string> => {
		setLoading(true);
		const storage = getStorage();
		const storageRef = ref(storage, path);

		return new Promise<string>((resolve, reject) => {
			uploadBytes(storageRef, file, UPLOAD_METADATA)
				.then((snapshot) => {
					getDownloadURL(snapshot.ref)
						.then((downloadURL) => {
							resolve(downloadURL);
						})
						.catch((error) => {
							reject(error);
						});
				})
				.catch((error) => {
					console.log("Error en funcion de carga", error);
					reject(error);
				})
				.finally(() => {
					setLoading(false);
				});
		});
	};

	const uploadPicture = async (
		path: string,
		picture: any,
		callback: (res: boolean, url: string) => void
	) => {
		try {
			const storage = getStorage();
			const storageRef = ref(storage, path);
			uploadBytes(storageRef, picture, UPLOAD_METADATA).then((snapshot) => {
				getDownloadURL(storageRef)
					.then((link) => callback(true, link))
					.catch((error) => {
						console.log("No se obtener el link de descarga", error);
						callback(false, "");
					});
			});
		} catch (error) {
			console.log("Error subiendo la imagen", error);
			callback(false, "");
		}
	};

	const deletePicture = async (
		path: string,
		callback: (res: boolean) => void
	) => {
		const storage = getStorage();
		const fileRef = ref(storage, path);

		deleteObject(fileRef)
			.then(() => {
				console.log("Archivo eliminado con éxito");
				callback(true);
			})
			.catch((error) => {
				console.error("Error al eliminar el archivo:", error);
				callback(false);
			});
	};

	return { loading, uploadFileToStorage, uploadPicture, deletePicture };
}
